import React from 'react';

const VisaDebitPaymentSvg = (props) => (
    <svg viewBox="0 0 48 32" {...props}>
        <path fill="#F7F7F7" d="M0 0h48v32H0z" />
        <path
            fill="#EBAA3E"
            d="M0 27h48v2.5c0 1.4-1.1 2.5-2.5 2.5h-43C1.1 32 0 30.9 0 29.5V27z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#0B5D9A"
            d="M38.4 20.8h2.5l-2.1-10.3h-2.2c-1 0-1.2.8-1.2.8l-4 9.5h2.8l.6-1.5h3.4l.2 1.5zm-3-3.6l1.4-3.9.8 3.9h-2.2zM31.5 13c-1.1-.6-3.8-.8-3.8.4 0 1.2 3.7 1.4 3.7 4.1 0 2.6-2.8 3.5-4.6 3.5-1.8 0-3-.6-3-.6l.4-2.3c1.1.9 4.4 1.1 4.4-.3 0-1.4-3.7-1.4-3.7-4.1 0-2.8 3.2-3.4 4.5-3.4 1.2 0 2.4.4 2.4.4l-.3 2.3m-9.3 7.8h-2.7l1.7-10.3h2.7l-1.7 10.3m-4.9-10.3h2.9l-4.3 10.3h-2.8l-2.3-9C9.3 11 8 10.7 8 10.7v-.2h4.2c1.2 0 1.3.9 1.3.9l.9 4.6.3 1.5 2.6-7"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#EE9F3F"
            d="M14.4 16.1l-.9-4.6s-.1-.9-1.3-.9H8v.2s2 .4 4 2c1.8 1.4 2.4 3.3 2.4 3.3"
        />
        <path
            fill="#575DC1"
            d="M2.5 0h43C46.9 0 48 1.1 48 2.5V5H0V2.5C0 1.1 1.1 0 2.5 0z"
        />
    </svg>
);

VisaDebitPaymentSvg.displayName = 'VisaDebitPaymentSvg';
export default VisaDebitPaymentSvg;
